import React from "react";
import PropTypes from "prop-types";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../components/layout/Header";
import LoginClient from "../components/Login/Client";
import LoginStaff from "../components/Login/Staff";
import Logout from "../components/Logout";
import Home from "../components/Home";
import CommunicationPreference from "../components/preferences/Communication";
import Token from "../components/Token";
import FourOhFour from "../components/FourOhFour";

import PageContent from "../components/layout/PageContent";

import AuthenticatedRoute from "../components/routes/AuthenticatedRoute";

const App = ({ loadedFromPersist, isLoggedIn, isSidebarOpen }) => {
	var ua = window.navigator.userAgent;
	var isIE = /MSIE|Trident/.test(ua);

	return (
		<div>
			<Header />
			<If condition={loadedFromPersist}>
				<PageContent isLoggedIn={isLoggedIn} isSidebarOpen={isSidebarOpen}>
					<Choose>
						<When condition={isIE}>
							<div className="alert alert-danger" role="alert">
								<h2>Your web browser Internet Explorer is out of date.</h2>
								<p>
									Newer browsers protect you better against viruses, scams and
									other threats. Outdated browsers have security holes which are
									fixed in updates.
								</p>
								<p>
									To ensure your access to the MyBudget portal remains secure,
									please download one of these up to date browsers:
								</p>
								<div style={{marginTop: "3em"}}>
								<table style={{width: "100%", textAlign: "center"}}>
									<tbody>
										<tr>
											<td>
												<a
													href="https://www.mozilla.org/firefox/new"
													target="_blank"
													rel="noopener"
													style={{
														backgroundImage:
															"url(https://browser-update.org/static/img/big/f.png)",
														paddingTop: 114,
														backgroundRepeat: "no-repeat",
														backgroundSize: "100px auto",
														backgroundPosition: "center 4px",
														display: "block"
													}}
													title="Download updated Firefox web browser from official Mozilla Foundation website!"												>
													<span>Firefox</span>
												</a>
											</td>
											<td>
												<a
													href="https://www.google.com/chrome/browser/desktop/"
													target="_blank"
													rel="noopener"
													style={{
														backgroundImage:
															"url(https://browser-update.org/static/img/big/c.png)",
														paddingTop: 114,
														backgroundRepeat: "no-repeat",
														backgroundSize: "100px auto",
														backgroundPosition: "center 4px",
														display: "block"
													}}
													title="Download updated Chrome web browser from official Google website!"
												>
													<span>Chrome</span>
												</a>
											</td>
											<td>
												<a
													href="https://www.microsoft.com/en-us/edge"
													target="_blank"
													rel="noopener"
													style={{
														backgroundImage:
															"url(https://browser-update.org/static/img/big/e.png)",
														paddingTop: 114,
														backgroundRepeat: "no-repeat",
														backgroundSize: "100px auto",
														backgroundPosition: "center 4px",
														display: "block"
													}}
													title="Download updated Edge web browser from official Microsoft website!"
												>
													<span>Edge</span>
												</a>
											</td>
										</tr>
									</tbody>
								</table>
								</div>
							</div>
						</When>
						<Otherwise>
							<Switch>
								<Route exact path="/login" component={LoginClient} />
								<Route exact path="/login/staff" component={LoginStaff} />
								<Route exact path="/logout" component={Logout} />

								<AuthenticatedRoute
									exact
									path="/token"
									component={Token}
									isLoggedIn={isLoggedIn}
								/>
								<AuthenticatedRoute
									exact
									path="/preferences/communication"
									component={CommunicationPreference}
									isLoggedIn={isLoggedIn}
								/>
								<AuthenticatedRoute
									exact
									path="/home"
									component={Home}
									isLoggedIn={isLoggedIn}
								/>
								<AuthenticatedRoute
									exact
									path="/"
									component={Home}
									isLoggedIn={isLoggedIn}
								/>
								<Route component={FourOhFour} />
							</Switch>
						</Otherwise>
					</Choose>
				</PageContent>
			</If>
		</div>
	);
};

App.propTypes = {
	isLoggedIn: PropTypes.bool,
	loadedFromPersist: PropTypes.bool,
	isSidebarOpen: PropTypes.bool,
};

// Need withRouter to rerender this section whenever a route changes
export default withRouter(
	connect((state, props) => {
		return {
			loadedFromPersist: state.Auth.loadedFromPersist,
			isLoggedIn:
				!!state.Auth.token && !props.location.pathname.includes("login"),
			isSidebarOpen: state.NavDraw.isOpen,
		};
	})(App)
);



// WEBPACK FOOTER //
// ./client/containers/App.js